var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"auto-padding pt-4 pb-2",attrs:{"elevation":"3"}},[_c('div',{staticClass:"flex items-center justify-start gap-10 mb-2"},[_c('div',[_c('h2',{staticClass:"text-3xl font-saira font-medium flex items-center"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }